"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var ColorIcon = function ColorIcon(_ref) {
  var size = _ref.size,
      icon = _ref.icon,
      viewBox = _ref.viewBox,
      color = _ref.color;
  return _react["default"].createElement("svg", {
    width: size.width ? typeof size.width === 'string' ? "".concat(size.width) : "".concat(size.width, "px") : "".concat(size, "px"),
    height: size.height ? typeof size.height === 'string' ? "".concat(size.height) : "".concat(size.height, "px") : "".concat(size, "px"),
    viewBox: viewBox,
    preserveAspectRatio: "none"
  }, icon.map(function (part) {
    return _react["default"].createElement("path", {
      fill: color || part.color,
      d: part.path,
      key: part.path
    });
  }));
};

var basicSizeType = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]);

ColorIcon.propTypes = {
  color: _propTypes["default"].string,
  icon: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  size: _propTypes["default"].oneOfType([basicSizeType, _propTypes["default"].exact({
    width: basicSizeType,
    height: basicSizeType
  })]),
  viewBox: _propTypes["default"].string
};
ColorIcon.defaultProps = {
  color: '',
  size: 32,
  viewBox: '0 0 1024 1024'
};
ColorIcon.displayName = 'ColorIcon';
var _default = ColorIcon;
exports["default"] = _default;